export const GET_ASPERA_DOWNLOADS = "GET_ASPERA_DOWNLOADS"
export const GET_ASPERA_DOWNLOADS_PENDING = "GET_ASPERA_DOWNLOADS_PENDING"
export const GET_ASPERA_DOWNLOADS_FAILED = "GET_ASPERA_DOWNLOADS_REJECTED"
export const GET_ASPERA_DOWNLOADS_FULFILLED = "GET_ASPERA_DOWNLOADS_FULFILLED"
